export default __webpack_public_path__ + "static/media/nslogo_white.eb70a983.png";